<template>
  <div class="point-title-warp">
    <div class="point"></div>
    <div class="title">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.point-title-warp {
  display: flex;
  align-items: center;
  // margin: 15px 0;
  .point {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: green;
  }
  .title {
    margin-left: 10px;
    color: green;
  }
}
</style>
